import { useOrderPaymentStep } from './useOrderPaymentStep'
import { OrderPaymentStepUI } from './OrderPaymentStepUI'

export const OrderPaymentStep = () => {
  const props = useOrderPaymentStep()
  return <OrderPaymentStepUI {...props} />
}
